import { MDBox } from "../MDBox";
import { MDTypography } from "../MDTypography";
import submission_screen from "../../../../assets/externalApplicationImages/submission_screen.png"
import { VerificationCompanyAtom } from "../../../../State/VerificationCompany.Atom";
import {useRecoilValue } from "recoil";

export const SubmittedScreenExternalApplication = () => {
  const verificationCompany = useRecoilValue(VerificationCompanyAtom);
  return (
    <>
      <MDBox sx={{ backgroundColor: "#FFFFFF", padding: "20px", margin: "30px" }}>
        <MDBox>
          <MDTypography sx={{ fontSize: "33px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", color: "#000000" }}>
            BEE Service Application Complete
          </MDTypography>
          <MDBox sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <img
              className="service_application_submission_image"
              src={submission_screen}
              style={{
                maxWidth: "180px",
                marginRight: "15px",
              }}
              alt="Service Application Submission Screen Image"
            />
          </MDBox>
          <MDTypography sx={{ fontSize: "15px", display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "12px", color: "#727272" }}>
            Your application is complete and has been sent to { verificationCompany.verificationAgency } for review.
          </MDTypography>
        </MDBox>
        <hr />
        <MDBox>
          <MDTypography sx={{ fontWeight: 'bold', color: "#000000", paddingBottom: "15px" }}>
            What you can expect next:
          </MDTypography>
          <div style={{ display: 'flex', gap: '20px', paddingBottom: '20px' }}>
            <MDBox
              sx={{
                border: '1px solid #CDCDCD',
                padding: '10px',
                width: '50%',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  style={{
                    backgroundColor: '#096E7E',
                    color: '#fff',
                    borderRadius: '50%',
                    width: '25px',
                    height: '25px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginRight: '7px',
                    fontSize: '14px',
                  }}
                >
                  1
                </div>
                <div>
                  <MDTypography sx={{ fontSize: '17px', color: '#000000' }}>Agency Review</MDTypography>
                </div>
              </div>
              <div>
                <MDTypography sx={{ fontSize: '14px', color: '#727272', paddingLeft: '31px' }}>
                  Your submitted details will undergo a thorough review by our agency, ensuring accuracy and completeness in alignment with BEE compliance requirements.
                </MDTypography>
              </div>
            </MDBox>
            <MDBox
              sx={{
                border: '1px solid #CDCDCD',
                padding: '10px',
                width: '50%',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  style={{
                    backgroundColor: '#096E7E',
                    color: '#fff',
                    borderRadius: '50%',
                    width: '25px',
                    height: '25px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginRight: '7px',
                    fontSize: '14px',
                  }}
                >
                  2
                </div>
                <div>
                  <MDTypography sx={{ fontSize: '17px', color: '#000000' }}>Agency Proposal</MDTypography>
                </div>
              </div>
              <div>
                <MDTypography sx={{ fontSize: '14px', color: '#727272', paddingLeft: '31px' }}>
                  After the review, our agency will create a customised proposal for your BEE service needs.
                </MDTypography>
              </div>
            </MDBox>
          </div>
        </MDBox >
      </MDBox>
    </>
  );
}